import { getMinImageDimensionSize, getUploadErrorMessages } from '#src/app/shared/utils/uppyUploader';

import type { Action } from './actions';
import type { ImageUploadState } from './context';

// eslint-disable-next-line complexity
export function imageUploadReducer(state: ImageUploadState, action: Action): ImageUploadState {
	switch (action.type) {
		case 'SET_IMAGE': {
			const { image, uploader } = action.payload;

			if (image && image.includes('data:image/') && !uploader.getFile()) uploader.addFile('image/jpeg', image);

			const newImage = action.payload.image || undefined;
			return {
				...state,
				image: newImage,
				imageChanged: newImage !== state.image && !action.payload.initialLoad,
				fileType: typeof image === 'string' ? image.substring('data:image/'.length, image.indexOf(';base64')) : null,
				errorMessage: null,
				cropper: newImage ? state.cropper : undefined,
			};
		}
		case 'SET_ERROR': {
			const { errorMessage } = action.payload;

			return {
				...state,
				errorMessage,
			};
		}
		case 'SET_IMAGE_CROP': {
			const { img, skipDimensionCheck } = action.payload;
			const width = img?.w;
			const height = img?.h;

			const minImageDimensionSize = getMinImageDimensionSize();
			if (
				!skipDimensionCheck &&
				((height && height < minImageDimensionSize.HEIGHT) || (width && width < minImageDimensionSize.WIDTH))
			) {
				return { ...state, imageCrop: img, errorMessage: getUploadErrorMessages().IMAGE_TOO_SMALL };
			}
			return { ...state, imageCrop: img };
		}
		case 'cropper/instance': {
			return {
				...state,
				cropper: action.payload.cropper,
			};
		}
		default: {
			return state;
		}
	}
}
